import React from "react";
import {Link, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import SendInstruction from "./SendInstruction";
import VerifyToken from "./VerifyToken";


const EmailConfirmation = () => {
    const {t} = useTranslation(['auth', 'validation']);

    // Get the reset token from the url
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return <Card>
        <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
        >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                {t('emailConfirmation.title')}
            </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
            {
                token ? <VerifyToken token={token} /> : <SendInstruction />
            }
            <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography
                    component={Link}
                    to="/auth/sign-in"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                >
                    {t('emailConfirmation.back')}
                </MDTypography>
            </MDBox>
        </MDBox>
    </Card>
}

export default EmailConfirmation;